module.exports = __webpack_public_path__ + "static/media/LS035Q7DD01_SPEC_LD2023702A_2023.10.25.2e8e08a1.pdf";